<template>
  <form-group label="Status do Anúncio" :columns="6">
    <select v-model="filters.status" class="form-select">
      <option :value=null>Todos</option>
      <option v-for="status in productStatuses" :value="status" :key="status">{{ $t(status).label }}</option>
    </select>
  </form-group>
</template>

<script>
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      productStatuses: ['active', 'denied', 'error', 'paused'],
      filters: {
        status: null
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {

    },
    watch: {
      'filters.status' () {
        this.$emit('change', this.filters)
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// MercadoLivre.vue?4848b4a0